import React from "react";
//#region types
import { FileUploaderProps } from "models/propTypes/wintFormPropsTypes";
import { TodoFileUploaderSectionProps } from "models/propTypes/missingDocumentPropTypes";
import { UploadedFile } from "models/utilTypes/fileUtilsTypes";
//#endregion
//#region components
import { VerticalFormField, FileUploader } from "components/common/wintForms";
import { Grid } from "@mui/material";
import { LocalizationHelperInstance } from "utils/helpers";
import { TranslationKeys } from "translations";
//#endregion

const TodoFileUploaderSection: React.FC<TodoFileUploaderSectionProps> = ({
  values,
  connect,
  onFilesUploadChange,
  oldAttachments,
}) => {
  const fileUploaderProps = connect("filesToUpload");

  React.useEffect(() => {
    // if there are old attachments, include them as uploaded files but locked and skip upload
    if (oldAttachments && oldAttachments.length > 0) {
      const files = fileUploaderProps.value as UploadedFile[];
      const oldFiles = oldAttachments.map((file) => ({
        ...file,
        locked: true,
        lockedText: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.MissingDocument.LockedFilesReason),
        skipOnFormSubmit: true,
      })).filter((file) => !files.some((f) => f.id === file.id)) as UploadedFile[];
      const newFiles = oldFiles.concat(files);
      fileUploaderProps.setValue(newFiles, true);
      onFilesUploadChange && onFilesUploadChange(newFiles);
    }
  }, [oldAttachments]);

  const onFilesUpload = (value?: UploadedFile[]) => {
    fileUploaderProps.setValue(value, true);

    onFilesUploadChange && onFilesUploadChange(value);

    if (!value || value.length === 0) {
      connect("type").setValue(undefined);
    }
  };

  return (
    <Grid container>
      {values.postWithoutPicture ? (
        <></>
      ) : (
        <VerticalFormField<FileUploaderProps>
          Component={FileUploader}
          {...fileUploaderProps}
          setValue={onFilesUpload}
          fileUploaderType="full"
          filePreviewElementId=""
        />
      )}
    </Grid>
  );
};

export default TodoFileUploaderSection;
